/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_item$ref = any;
export type PdpSharedDetailShipping_item$ref = any;
export type PdpSharedDetailShipping_item = {
    readonly hasShipmentQuotes: boolean | null;
    readonly hasPreQuotedShipping: boolean | null;
    readonly itemIsOnHold: boolean | null;
    readonly attributes: {
        readonly leadTime: ReadonlyArray<{
            readonly option: {
                readonly urlLabel: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_item$ref;
    readonly " $refType": PdpSharedDetailShipping_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetailShipping_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasShipmentQuotes",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasPreQuotedShipping",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": "itemIsOnHold",
            "name": "isOnHold",
            "args": [
                {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userId"
                }
            ],
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "attributes",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemAttributes",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "leadTime",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "AttributeValue",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "option",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "AttributeOption",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "urlLabel",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '9f687a3b730ebc5ca0523cfc380df721';
export default node;
